import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import Contact from './solutions-elements/contact';
import Hero from './solutions-elements/hero';
import LivewireNetwork from './solutions-elements/livewire-network';
import SophisticatedInvestors from './solutions-elements/sophisticated-investors';
import ProfessionalInvestors from './solutions-elements/professional-investors';
import SolutionsSection from './solutions-elements/solutions';
import FundManagement from './solutions-elements/fund-management';
import Testimonial from './solutions-elements/testimonial';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  font-family: Lato, Texta, Arial, Helvetica, sans-serif !important;

  button {
    font-size: 14px;
    font-family: Lato, Texta, Arial, Helvetica, sans-serif !important;
    padding: 8px 16px;
  }
`;

export default function Solutions(props) {
  const state = {
    ...props,
    ...commonProps(),
    light: false,
  };

  return (
    <ThemeProvider theme={state}>
      <Container>
        <Hero />
        <LivewireNetwork />
        <SophisticatedInvestors />
        <ProfessionalInvestors />
        <SolutionsSection />
        <FundManagement />
        <Testimonial />
        <Contact formId="get_in_touch" formName="get_in_touch" formTitle="Ready to Amplify Your Reach?" />
      </Container>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
Solutions.propTypes = {
  logo: PropTypes.string.isRequired,
  hero: PropTypes.string.isRequired,
  heroPortrait: PropTypes.string.isRequired,
  investorEngagementImg: PropTypes.string.isRequired,
  footprintImg: PropTypes.string.isRequired,
  ongoingContentSupportImg: PropTypes.string.isRequired,
  partnerImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  testimonialImages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
/* eslint-enable react/no-unused-prop-types */
